import spanishMessages from "../i18n/es";
import englishMessages from "../i18n/en";

export default locale => {
  if (locale === "es") {
    return spanishMessages;
  } else if (locale === "en") {
    return englishMessages;
  }

  // Always fallback on english
  return spanishMessages;
};
